import { buildAxiosErrorMessage } from '@/utils/buildAxiosErrorMessage'
import * as Sentry from '@sentry/react'
import axios from 'axios'
import { setupAuthInterceptor } from './axios.interceptors'

export const axiosRadar = axios.create({
  timeout: 20000,
  baseURL: import.meta.env.VITE_URL_RADAR_API,
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

// Setup auth interceptor
setupAuthInterceptor(axiosRadar)

// Error handling interceptor
axiosRadar.interceptors.response.use(undefined, error => {
  const errorMessage = buildAxiosErrorMessage(error, 'Radar Error')
  console.error(errorMessage)
  Sentry.captureException(errorMessage)
})
